function _jade_template_fn(locals) {
  locals = locals || {};;;
  var result_of_with = (function($attr, $helpers, JSON, Object, String) {
    var h = require("panel").h;
    var __vjadeStringifyAttrsIfObj = function(attrs) {
      if (typeof attrs !== 'object') return attrs;
      const copy = {};
      for (const [k, v] of Object.entries(attrs)) {
        copy[k] = typeof attrs[k] === 'object' ? JSON.stringify(v) : v;
      }
      return copy;
    }

    var __vjadeSafeCode = function(code) {
      return code || String(code);
    };
    return {
      value: (h("div", {
        "class": {
          'retention-line-chart': true
        },
      }, (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat((!$helpers.hasResults() && $attr(`disable-empty-state`)) ? ((function() {
          var __jade_nodes = []; /*  nothing */ ;
          return __jade_nodes
        }).call(this)) : ((function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("mp-legend-line-chart", {
            "attrs": __vjadeStringifyAttrsIfObj({
              'chart-height': $attr(`chart-height`),
              'display-analysis-type': `linear`,
              'display-context': $attr(`display-context`),
              'has-no-data': !$helpers.hasResults(),
              'incomplete-to-date': $helpers.isEndDateIncomplete(),
              'legend-sections': $helpers.getLegendSections(),
              'legend-theme': $attr(`legend-theme`),
              'x-axis-options': $helpers.getXAxisOptions(),
            }),
            "props": {
              chartData: $helpers.getChartData(),
              formatTicksX: $helpers.formatTicksX,
              formatXAxisLabel: $helpers.formatXAxisLabel,
              formatYAxisLabel: $helpers.formatYAxisLabel,
              formatTooltip: $helpers.getFormatTooltip,
            },
            "on": {
              togglecheckbox: $helpers.handleCheckboxToggled
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat((!$helpers.hasResults()) ? ((function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("div", {
                "attrs": __vjadeStringifyAttrsIfObj({
                  slot: `empty-state`
                }),
                "class": {
                  'retention-no-data': true
                },
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(h("div", {
                  "class": {
                    'retention-no-data-img': true
                  },
                }));
                __jade_nodes = __jade_nodes.concat(h("div", {
                  "class": {
                    'retention-no-data-text': true
                  },
                }, (function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat("We couldn't find any data for your query.");;
                  return __jade_nodes
                }).call(this).filter(Boolean)));;
                return __jade_nodes
              }).call(this).filter(Boolean)));;
              return __jade_nodes
            }).call(this)) : undefined);;
            return __jade_nodes
          }).call(this).filter(Boolean)));
          __jade_nodes = __jade_nodes.concat(($attr(`download-mode`) && $attr(`is-download-truncated`)) ? ((function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": {
                'truncated-data-download-text': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat("Results have been truncated to the first 30 results for download.");;
              return __jade_nodes
            }).call(this).filter(Boolean)));;
            return __jade_nodes
          }).call(this)) : undefined);
          __jade_nodes = __jade_nodes.concat((!$attr('show-legend') && !$helpers.isDisplayedAsDashboardCard()) ? ((function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": {
                'retention-line-chart-footnote': true
              },
            }, [__vjadeSafeCode($helpers.getChartNoteLabel())]));;
            return __jade_nodes
          }).call(this)) : undefined);;
          return __jade_nodes
        }).call(this)));;
        return __jade_nodes
      }).call(this).filter(Boolean)))
    };

  }.call(this, "$attr" in locals ? locals.$attr : typeof $attr !== "undefined" ? $attr : undefined, "$helpers" in locals ? locals.$helpers : typeof $helpers !== "undefined" ? $helpers : undefined, "JSON" in locals ? locals.JSON : typeof JSON !== "undefined" ? JSON : undefined, "Object" in locals ? locals.Object : typeof Object !== "undefined" ? Object : undefined, "String" in locals ? locals.String : typeof String !== "undefined" ? String : undefined));
  if (result_of_with) return result_of_with.value;
}
module.exports = _jade_template_fn;